
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/services/[slug]/[subSlug]",
      function () {
        return require("private-next-pages/preview/services/[slug]/[subSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/services/[slug]/[subSlug]"])
      });
    }
  